module.exports = {
          srcSet: __webpack_public_path__ + "images/1904-ec96fd2945fa6a0704e891308f3a6974-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1904-80125b3a46c609ca51b68a56c10cca81-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1904-ec96fd2945fa6a0704e891308f3a6974-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1904-80125b3a46c609ca51b68a56c10cca81-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1904-ec96fd2945fa6a0704e891308f3a6974-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1904-ec96fd2945fa6a0704e891308f3a6974-320.jpg"},
          
          width: 320,
          height: 251
        }